import {strcmp} from "../util";

export default class HomeCtrl {

  typOdpoctuOptionsPLYN = [
    {"label": "K (Kontrolní odečet)", value: "K"},
    {"label": "F (Fakturační odečet)", value: "F"},
    {"label": "Z (odečet ke Změně dodavatele)", value: "Z"},
    {"label": "P (odečet při Přepisu)", value: "P"},
    {"label": "N (kontrolní odečet Novým dodavatelem)", value: "N"},
    {"label": "U (odečet k Ukončení dodávky z OTE)", value: "U"},
  ];
  typOdpoctuOptionsEE = [
    {"label": "Ke změně ceny k 31. 12.", value: "C"},
    {"label": "Pro vystavení mimořádné faktury ke změně ceny", value: "M" },
    {"label": "Nespecifikovaný důvod", value: "X"}
  ]

  constructor(AuthService, KontaktService, OdberneMiestoService, SamoodpocetService, $state, $stateParams){
    this.OdberneMiestoService = OdberneMiestoService;
    this.SamoodpocetService = SamoodpocetService;
    this.$state = $state;

    this.kontakt = {};
    KontaktService.get(AuthService.user.odberatel.id)
    .then(k => (k.odberneMiesta.sort((a,b)=>strcmp(a.mesto, b.mesto)),k) )
    .then(k => this.kontakt = k)
    .then(() => this.showOdberneMiesta());


    this.odberneMiesta = [];
    this.samoodpocetVisible = {};
    this.rkVisible = {};
    this.dkVisible = {};
    this.omDetails = {};
    this.meradlaByOm = {};
    this.samoodpocetForm = {};

    this.filter = {
      typ: 'PLYN',
      search: ""
    };

    if($stateParams.typ == "PLYN" || $stateParams.typ == "EE"){
      this.filter.typ = $stateParams.typ;
    }
  }

  showOdberneMiesta(){
    const query = this.filter.search.toLowerCase();
    const searchFn = function(om, query){
      if(query == "") return true;
      if(om.mesto.toLowerCase().indexOf(query) >= 0) return true;
      if(om.kod.toLowerCase().indexOf(query) >= 0) return true;
      if(om.ulica.toLowerCase().indexOf(query) >= 0) return true;
      return false;
    };
    this.odberneMiesta = this.kontakt.odberneMiesta
      .filter(om => om.typ == this.filter.typ)
      .filter(om => searchFn(om, query))
  }

  samoodpocet(_om){
    this.samoodpocetVisible[_om.id] = !this.samoodpocetVisible[_om.id];
    if(this.samoodpocetVisible[_om.id]){
      this.OdberneMiestoService.getForSamoodpocet(_om.id).then(om => {
        this.meradlaByOm[om.id] = om.meradla;
        om.meradla.forEach(m => {
          this.samoodpocetForm[m.id] = {
            typ: _om.typ=="PLYN"?"F":"X",
            typOptions: _om.typ=="PLYN"?this.typOdpoctuOptionsPLYN:this.typOdpoctuOptionsEE
          }
        });
      });
    }
  }

  rk(_om){
    this.rkVisible[_om.id] = !this.rkVisible[_om.id];
    if(this.rkVisible[_om.id]){
      this.OdberneMiestoService.get(_om.id).then(om => this.omDetails[_om.id] = om);
    }
  }

  dk(_om){
    this.dkVisible[_om.id] = !this.dkVisible[_om.id];
    if(this.dkVisible[_om.id]){
      this.OdberneMiestoService.get(_om.id).then(om => this.omDetails[_om.id] = om);
    }
  }

  saveSamoodpocet(om, meradlo){
    this.samoodpocetForm[meradlo.id].error = false;
    this.SamoodpocetService.submit([{
      kodOM: om.kod,
      cisloMeradla: meradlo.cislo,
      datum: this.samoodpocetForm[meradlo.id].datum,
      stavMeradla: this.samoodpocetForm[meradlo.id].stavMeradla,
      stavMeradla2: this.samoodpocetForm[meradlo.id].stavMeradla2,
      typ: this.samoodpocetForm[meradlo.id].typ
    }]).then((result) => {
      result = result[0];
      if(result){
        if(result.status < 0){
          this.samoodpocetForm[meradlo.id].saved = false;
          this.samoodpocetForm[meradlo.id].error = true;
          this.samoodpocetForm[meradlo.id].message = result.note;
        }else{
          this.samoodpocetForm[meradlo.id].saved = true;
        }
      }
    }, (error)=> {
      console.log(error);
      this.samoodpocetForm[meradlo.id].error = true;
      this.samoodpocetForm[meradlo.id].message = "Systémová chyba ";
      try{
        this.samoodpocetForm[meradlo.id].message += JSON.stringify(error);
      }catch(e){
        
      }
    })
  }

}


// WEBPACK FOOTER //
// ./src/Home/HomeCtrl.js